export default {
    uploading: 1,
    finished: 2,
    failed: 3,
}
